import { render, staticRenderFns } from "./IndustryLabelGroup.vue?vue&type=template&id=a0d02a88&scoped=true&"
import script from "./IndustryLabelGroup.vue?vue&type=script&lang=js&"
export * from "./IndustryLabelGroup.vue?vue&type=script&lang=js&"
import style0 from "./IndustryLabelGroup.vue?vue&type=style&index=0&id=a0d02a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d02a88",
  null
  
)

export default component.exports